import * as $ from 'jquery';
import 'bootstrap';
import * as Slideout from 'slideout';

export class mHolidaysHeader {
	$scope: any = $('#m-holidays-header');
	$navbarToggle: any = $('#m-holidays-header .navbar-toggle');
	$mholidaysContent: any = $('#mholidays-content');

	// Initialize mobile slider navigation
	slideNav(): void {
		let _self = this;
	// 8137 and 8138 start
	if($('ul.navbar-nav.desktop-nav li').length == 0)
	{
	$('.navbar-toggle .burger').hide();
	$('.navbar-toggle').css("pointer-events","none");
	}
	// 8137 and 8138 end

		var slideout: any = new Slideout({
			'panel': document.getElementById('mholidays-content'),
			'menu': $('.mab-nav--overlay')[0],
			'padding': '1210px',
			'tolerance': 70,
			'side': 'right',
			'easing': 'cubic-bezier(.32,2,.55,.27)'
		});
		var slideoutSide:any = new Slideout({
			'panel': document.getElementById('mholidays-content'),
			'menu': $('.mab-nav--overlay')[0],
			'padding': 310,
			'tolerance': 70,
			'side': 'right',
			'easing': 'cubic-bezier(.32,2,.55,.27)'
		});

		_self.$scope.find('.navbar-toggle').on('click', () => {
			if (window.innerWidth < 768) {
				slideout.toggle();
			} else {
				slideoutSide.toggle();
			}
		});

		let top: number = 0;
		let $body: any = $('body');
		slideout.on('open', () => {
			// top = $(window).scrollTop();
			// $body.css({
			// 	'position': 'fixed',
			// 	'top': -top
			// });
		});
		slideoutSide.on('open', () => {
			// top = $(window).scrollTop();
			// $body.css({
			// 	'position': 'fixed',
			// 	'top': -top
			// });
		});

		slideout.on('close', () => {
			// $body.css({
			// 	'position': '',
			// 	'top': ''
			// });
			// $body.scrollTop(top);
		});
		slideoutSide.on('close', () => {
			// $body.css({
			// 	'position': '',
			// 	'top': ''
			// });
			// $body.scrollTop(top);
		});

		// when slideout is open, on click main content area, close menu
		slideout
			.on('open', function () {
				_self.$mholidaysContent.addClass('slideout-open');
				_self.$mholidaysContent.on('click', function (e: any) {
					slideout.close();
				});
			})
			.on('close', function () {
				_self.$mholidaysContent.removeClass('slideout-open');
				_self.$mholidaysContent.unbind('click');
			});
		slideoutSide
			.on('open', function () {
				_self.$mholidaysContent.addClass('slideout-open');
				_self.$mholidaysContent.on('click', function (e: any) {
					slideoutSide.close();
				});
			})
			.on('close', function () {
				_self.$mholidaysContent.removeClass('slideout-open');
				_self.$mholidaysContent.unbind('click');
			});

		$('.slideOutClose').click(function() {
			if (window.innerWidth < 768) {
				slideout.close();
			} else {
				slideoutSide.close();
			}
		});
	}
}

let scope: Element = document.querySelector('#m-holidays-header');
if (scope) {
	try {
		let mholidaysheader = new mHolidaysHeader();
		$(document).ready(function () {
			if ($('#mholidays-content').length > 0) {
				mholidaysheader.slideNav();
			}
		});
	} catch (e) { console.error(e); }
}